$shm_hitalama_map_widget_float_settings_text_md $shm_hitalama_map_widget_float_settings
	controlled_settings_content /
		<= Link_favicon $mol_check_box
			title \Иконки сайтов у ссылок
			checked? <=> link_favicon? true
		<= Code
